import { render } from "./FormatListChecksIcon.vue?vue&type=template&id=45bf6af2"
import script from "./FormatListChecksIcon.vue?vue&type=script&lang=js"
export * from "./FormatListChecksIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__